import { riskBadgeClass } from '../../lib/formatters';

interface BadgeProps {
  level: 'HIGH' | 'MEDIUM' | 'LOW';
}

export function RiskBadge({ level }: BadgeProps) {
  return <span className={riskBadgeClass(level)}>{level}</span>;
}

interface StatusBadgeProps {
  positive: boolean;
  label?: string;
}

export function StatusBadge({ positive, label }: StatusBadgeProps) {
  return (
    <span className={positive ? 'badge-low' : 'badge-high'}>
      {label ?? (positive ? 'Achievable' : 'At Risk')}
    </span>
  );
}
